import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { TemplateTextComponent } from "../../templates/template-text/template-text.component";

@Component({
  selector: "app-prefix-hi3",
  imports: [TemplateTextComponent],
  templateUrl: "./prefix-hi3.component.html",
  styleUrl: "./prefix-hi3.component.less",
})
export class PrefixHi3Component extends PrefixComponent<string> {
  public constructor() {
    super();
    this.hide = true;
    this.post = false;
    this.characters = ALLOWED_CHARACTERS["hi3"];
  }
}
